// extracted by mini-css-extract-plugin
export var isPrintedCell = "_wy-1";
export var printerIcon = "_wy-0";